import React, {useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {ModalProps} from "scholastic-client-components/src/ui/Modal/Modal"
import {ModalWrapperFC} from "scholastic-client-components/src/modals/modalWrapper"
import {CenteredModal} from "scholastic-client-components/src/ui/Modal/CenteredModal"
import {AdjustableScrollbars} from "scholastic-client-components/src/ui/Scrollbars"
import styles from "./TOSModal.module.scss"
import {Checkbox} from "scholastic-client-components/src/ui/Checkbox/Checkbox"
import {Button} from "scholastic-client-components/src/ui/Button/Button"
import {authSelectors, authSlice} from "scholastic-client-components/src/slices/authSlice"
import {GeneralPolicyBody, GeneralPolicyHeader} from "../PrivacyPolicy/General/GeneralPolicy"
import {TermsOfUse} from "../TermsOfUse"
import {Trans, useTranslation} from "react-i18next"

type TOSModalProps = {
    onAgreeClick: () => void
    loading: boolean
}

const TOSModal: React.FC<ModalProps & TOSModalProps> = ({
    open,
    onClose,
    id,
    onAgreeClick,
    loading,
}) => {
    const {t} = useTranslation(["auth_portal"])
    const [agreementChecked, setAgreementChecked] = useState(false)

    return (
        <CenteredModal
            overlayClassName={styles.overlay}
            className={styles.tosModal}
            id={id}
            open={open}
            onClose={onClose}
            showCloseIcon={false}
            ownScroll
            animation="opacity"
            center
            withoutHeader
            noBottomPadding
            closeOnEsc={false}
        >
            <div className={styles.inner}>
                <h1 className={styles.title}>{t("auth_portal:tos_modal.title")}</h1>
                <div className={styles.subtitle}>{t("auth_portal:tos_modal.description")}</div>
                <AdjustableScrollbars autoHeightMax={364}>
                    <TermsOfUse className={styles.termsOfUse} smallerTitle />
                    <GeneralPolicyHeader small />
                    <GeneralPolicyBody />
                </AdjustableScrollbars>
                <div className={styles.actions}>
                    <Checkbox
                        checked={agreementChecked}
                        onChange={(e) => {
                            setAgreementChecked(e.target.checked)
                        }}
                    >
                        <Trans
                            i18nKey={"auth_portal:tos_modal.agreement_checkbox"}
                            components={{
                                bold: <strong className={styles.strong} />,
                            }}
                        />
                    </Checkbox>
                    <Button className={styles.cancel} disabled={loading} onClick={onClose}>
                        {t("auth_portal:tos_modal.cancel_button")}
                    </Button>
                    <Button
                        loader={loading}
                        onClick={onAgreeClick}
                        disabled={!agreementChecked}
                        primary
                    >
                        {t("auth_portal:tos_modal.agree_button")}
                    </Button>
                </div>
            </div>
        </CenteredModal>
    )
}

export const WrappedTOSModal: React.FC<TOSModalProps> = (modalProps) => {
    const dispatch = useDispatch()
    const requestTOSAgreement = useSelector(authSelectors.getRequestTOSAgreement)

    return (
        <ModalWrapperFC
            useDispatch={useDispatch}
            open={!!requestTOSAgreement}
            position={"center"}
            renderModal={(props) => (
                <TOSModal
                    onClose={() =>
                        dispatch(
                            authSlice.actions.setRequestTOSAgreement({requestTOSAgreement: false})
                        )
                    }
                    {...modalProps}
                    {...props}
                />
            )}
        />
    )
}
